var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"client-preference-results"},[_c('ClientPreferenceResults',{attrs:{"screen-sets":_vm.screenSetsWithMetricInfo,"assigned-colors":_vm.assignedColors,"entity":_vm.entity,"features":_vm.features}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }